/**
 * Marca que o cliente derrubou a sessão (refresh do keycloak falhou).
 *
 * O proxy só sabe se o usuário está autenticado pela presença do cookie de sessão.
 * Quando o backend recusa o refresh mas o cookie continua no browser, o redirect
 * "autenticado não fica no login" jogaria o usuário de volta na rota privada, que
 * tenta o refresh outra vez — loop infinito de navegação. Este parâmetro quebra o loop.
 */
export const SESSION_EXPIRED_QUERY_PARAM = 'session';
export const SESSION_EXPIRED_QUERY_VALUE = 'expired';
